import type { ElemetalInfosData } from '../api/elementals'
import type { Elemental, ElementalTypeEnum } from '../types/elemental'
import { useRemoveSaveElemental } from './mutations/elemetal/useRemoveSaveElemental'
import { useSaveElemental } from './mutations/elemetal/useSaveElemental'

export function useSave(element: Ref<Elemental | null | undefined>, type: Ref<ElementalTypeEnum | null | undefined>, infos: Ref<ElemetalInfosData | null | undefined>, listId?: string) {
  const user = useUser()
  const router = useRouter()
  const toast = useToast()
  const { mutate: removeSave, isPending: isPendingRemove } = useRemoveSaveElemental()
  const { mutate, isPending } = useSaveElemental()
  const isSaved = computed(() => infos.value?.isSaved ?? false)
  const save = () => {
    if (!user.value || !infos.value) {
      const path = useGetLoginURL()
      router.push(path)
      return
    }

    const isSaved = infos.value?.isSaved

    const elementalRaw = unref(element)
    if (!elementalRaw || !type.value)
      return
    const data = {
      id: elementalRaw.id,
      elementalType: type.value,
      listId,
      slug: elementalRaw.url,
    }
    if (!isSaved) {
      mutate(data, {
        onError: (error) => {
          console.error(error)
          return toast.warning(error.message, { id: 'save-error' })
        },
      })
    }
    else {
      removeSave(data, {
        onError: (error) => {
          console.error(error)
          return toast.warning(error.message, { id: 'save-error' })
        },
      })
    }
  }

  return {
    isPending: computed(() => isPendingRemove.value || isPending.value),
    save,
    isSaved,
  }
}
